const availablePrices = {
  AED: {
    "Startup Registration": "price_1NYgkAGlqmUCDtkjczVkNXml",
    "Content Access": "price_1Ny9RUGlqmUCDtkjWKjswYRk",
    "VC Registration": "price_1PIhPSGlqmUCDtkjcRR6L7HH",
    "Angel Investor Registration": "price_1QPEfBGlqmUCDtkjo8CH9rHZ",
  },
  IDR: {
    "Startup Registration": "price_1NYbbqGlqmUCDtkjLR892I0S",
    "Content Access": "price_1Ny9kiGlqmUCDtkjbEMUMIHq",
    "VC Registration": "price_1PIhPSGlqmUCDtkjs3bvPQNW",
    "Angel Investor Registration": "price_1QPErmGlqmUCDtkjxjKRhFMA",
  },
  USD: {
    "Startup Registration": "price_1Nl7zkGlqmUCDtkjwPFUcbSa",
    "Content Access": "price_1Ny9SZGlqmUCDtkjtDAWacNF",
    "VC Registration": "price_1PZVOOGlqmUCDtkjmo63NP6N",
    "Angel Investor Registration": "price_1QPEfBGlqmUCDtkjIg2qkfDe",
  },
  JOD: {
    "Startup Registration": "price_1Nl7zQGlqmUCDtkjlOPPDVED",
    "Content Access": "price_1Ny9WWGlqmUCDtkjEOh1Ul0c",
    "VC Registration": "price_1PsYj4GlqmUCDtkjbZv0wfnr",
    "Angel Investor Registration": "price_1QPEfBGlqmUCDtkjIg2qkfDe",
  },
  SAR: {
    "Startup Registration": "price_1Nl7yaGlqmUCDtkjIyczrp2Q",
    "Content Access": "price_1Ny9TqGlqmUCDtkj38V6znqg",
    "VC Registration": "price_1PZVQdGlqmUCDtkjlo1vS0Ff",
    "Angel Investor Registration": "price_1QPEfBGlqmUCDtkjXBTpHpHB",
  },
  EGP: {
    "Startup Registration": "price_1Nl7ywGlqmUCDtkjF2AWcNob",
    "Content Access": "price_1Ny9UmGlqmUCDtkjurbE9Px7",
    "VC Registration": "price_1PsYhvGlqmUCDtkjObfjymoQ",
    "Angel Investor Registration": "price_1QPEfBGlqmUCDtkjIg2qkfDe",
  },
};

// UAE
// Monthly:price_1Ny9QrGlqmUCDtkj5ZIKlcZD
// Yearly: price_1Ny9RUGlqmUCDtkjWKjswYRk

// USD: 
// Monthly: price_1Ny9RpGlqmUCDtkjsVUrLe3l
// Yearly: price_1Ny9SZGlqmUCDtkjtDAWacNF

// Jordan:
// Monthly:price_1Ny9W0GlqmUCDtkj4q6Hp5Y0
// Yearly: price_1Ny9WWGlqmUCDtkjEOh1Ul0c

// KSA:
// Monthly: price_1Ny9TUGlqmUCDtkjMVMIRlnH
// Yearly: price_1Ny9TqGlqmUCDtkj38V6znqg

// Egypt:
// Monthly: price_1Ny9UPGlqmUCDtkjFA7bwNcy
// Yearly: price_1Ny9UmGlqmUCDtkjurbE9Px7


export default availablePrices;
